const zh_TW = {
    'components.searchPanel.title': "查詢與篩選",
    'components.searchPanel.open':"展開",
    'components.searchPanel.fold':"收起",
    'components.searchPanel.empty':"清空",
    'components.searchPanel.search':"查詢",
    'intl.title': "平臺-督辦任務主表國家",
    'intl.button.create': "新增",
    'intl.button.submit':"提交",
    'intl.button.recovery':"回收",
    'intl.button.print': "打印",
    'intl.button.templateDownload': "模版下載",
    'intl.button.import': "導入",
    'intl.button.export': "導出",
}
export default zh_TW;


// WEBPACK FOOTER //
// ./src/components/Intl/locales/zh_tw.js